import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"

export default function Dashboard() {
    const { t } = useTranslation()

    return (
        <Container className='p-5'>
            <Row>
                <Col>
                    <div className='sd-label-dashboard'>{t('admin.dashboard.welcome')}</div>
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col>
                    <h3>{t('admin.dashboard.subwelcome')}</h3>
                </Col>
            </Row>
        </Container>
    )
}